module.exports = __webpack_public_path__ + "static/media/icon-mail-outline.2d5c0a4a.svg";